import { render, staticRenderFns } from "./SYService.vue?vue&type=template&id=54246482&"
import script from "./SYService.vue?vue&type=script&lang=js&"
export * from "./SYService.vue?vue&type=script&lang=js&"
import style0 from "./SYService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports